﻿<rdo-overlay [enabled]="loadingProductTypesRentalGrowth"></rdo-overlay>

@if (selectedProductTypeService.isProductSelected && data) {
  <rental-growth-grid [data]="data" />
}

@if (((!currentMonthRaw || !previousMonthRaw) && !loadingProductTypesRentalGrowth)) {
  <div class="no-data-available">
    {{'main.tabs.equipment.product_types.no_data_available' | translate}}
  </div>
}

@if (selectedProductTypeService.isProductSelected && data!==null && chartData!==null && !loadingChart) {
  <rdo-rental-growth-chart [chart-data]="chartData" />
}
@if (chartData===null && data!==null && loadingChart) {
  <rdo-loader id="chart-loader" class="chart-loader" />
}
